import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Name = styled.h1`
  margin: 0 0 20px;
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 24px;
  font-weight: 700;
  color: ${colors.textPrimary};
`;

export const TabContent = styled.div`
  margin-top: 20px;
`;

export const InfoList = styled.dl`
  display: grid;
  grid-template-columns: minmax(120px, 200px) minmax(0, 1fr);
  gap: 12px 16px;
  margin: 0 0 24px;
  font-size: 14px;
`;

export const InfoLabel = styled.dt`
  color: ${colors.textSecondary};
`;

export const InfoValue = styled.dd`
  margin: 0;
  color: ${colors.textPrimary};
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const PayoutActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

export const MutedLine = styled.div`
  font-size: 12px;
  color: ${colors.textSecondary};
`;
